module.exports = "<p>\r\n  account-single-ticket works!\r\n</p>\r\n"